import script from "./StepImage.vue?vue&type=script&setup=true&lang=js"
export * from "./StepImage.vue?vue&type=script&setup=true&lang=js"

import "./StepImage.vue?vue&type=style&index=0&id=02794391&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02794391"]])

export default __exports__